import _pt from "prop-types";
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";

/**
 * Can only be used as a child of `Select`
 */
var Option = function Option(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      value = _ref.value;
  return ___EmotionJSX("option", {
    disabled: disabled,
    value: value
  }, children);
};

Option.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _pt.string.isRequired,
  disabled: _pt.bool,
  value: _pt.string.isRequired
} : {};
export default Option;